import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import {
  FaWallet,
  FaCubes,
  FaHardHat,
  FaChartLine,
  FaGamepad,
  FaMap,
  FaGlobe,
  FaBars,
  FaTimes,
  FaFileAlt,
} from "react-icons/fa";
import axios from "axios";
import logo from "../assets/images/logo.webp";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [highestPrice, setHighestPrice] = useState(null);

  useEffect(() => {
    const fetchPrice = async () => {
      try {
        const response = await axios.get("https://explorer.menelik.cc:3300/api/prices");
        if (response.data.length > 0) {
          const highest = response.data.reduce((max, item) =>
            parseFloat(item.last_price) > parseFloat(max.last_price) ? item : max
          );
          setHighestPrice(highest);
        }
      } catch (error) {
        console.error("Error fetching price data:", error);
      }
    };
    fetchPrice();
  }, []);

  const menuItems = [
    { name: "Blockchain", icon: <FaCubes />, href: "#about" },
    { name: "Mining", icon: <FaHardHat />, href: "#mining" },
    { name: "Staking", icon: <FaChartLine />, href: "#staking" },
    { name: "Features", icon: <FaCubes />, href: "#features" },
    { name: "Gaming", icon: <FaGamepad />, href: "#gaming" },
    { name: "Wallet", icon: <FaWallet />, href: "#wallet" },
    { name: "Explorer", icon: <FaGlobe />, href: "https://explorer.menelik.cc/", external: true },
    { name: "Whitepaper", icon: <FaFileAlt />, href: "https://menelikcoin.gitbook.io/whitepaper", external: true },
    { name: "Roadmap", icon: <FaMap />, href: "https://roadmap.menelik.cc/", external: true },
  ];

  return (
    <nav className="bg-black bg-opacity-90 backdrop-blur-md shadow-lg fixed top-0 w-full z-50">
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-red-700 via-red-500 to-red-700"></div>

      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <img src={logo} alt="Menelik Logo" className="h-10 w-auto" />
          <motion.div
            initial={{ x: -50, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
            className="text-2xl font-bold text-yellow-400"
          >
            Menelik
          </motion.div>
        </div>

        {highestPrice && (
          <motion.div
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="hidden lg:flex items-center bg-green-700 text-white px-4 py-1 rounded-full shadow-lg"
          >
            <span className="font-semibold">${parseFloat(highestPrice.last_price).toFixed(8)}</span>
          </motion.div>
        )}

        <div className="hidden lg:flex space-x-6">
          {menuItems.map((item, index) => (
            <a
              key={index}
              href={item.href}
              target={item.external ? "_blank" : ""}
              rel={item.external ? "noopener noreferrer" : ""}
              className="text-gray-300 hover:text-yellow-400 flex items-center space-x-2 transition duration-300"
            >
              {item.icon}
              <span>{item.name}</span>
            </a>
          ))}
        </div>

        <button
          className="lg:hidden text-yellow-400 text-2xl"
          onClick={() => setIsOpen(!isOpen)}
        >
          {isOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {isOpen && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          transition={{ duration: 0.4 }}
          className="lg:hidden bg-black bg-opacity-90 backdrop-blur-md px-6 py-4 flex flex-col space-y-3 border-t border-red-600"
        >
          {menuItems.map((item, index) => (
            <a
              key={index}
              href={item.href}
              target={item.external ? "_blank" : ""}
              rel={item.external ? "noopener noreferrer" : ""}
              className="text-gray-300 hover:text-yellow-400 flex items-center space-x-3 transition duration-300 py-2 border-b border-gray-700"
            >
              {item.icon}
              <span>{item.name}</span>
            </a>
          ))}
        </motion.div>
      )}
    </nav>
  );
};

export default Navbar;
